import Parsley from 'parsleyjs';

import 'parsleyjs/dist/i18n/nl';
import 'parsleyjs/dist/i18n/de';

Parsley.options.errorClass = 'is-error';
Parsley.options.excluded = 'input[type=button], input[type=submit], input[type=reset], input[type=hidden], [disabled], :hidden';
Parsley.options.successClass = 'is-success';

Parsley.addMessages('nl', {
    mincheck: 'Selecteer tenminste %s optie(s).',
    maxcheck: 'Selecteer maximaal %s optie(s).',
    check: 'Selecteer tussen %s en %s optie(s).'
}).setLocale(document.documentElement.lang);

$('form:not([novalidate])').parsley();
